import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { getAllAuditLogs, getAllBrands } from '../../store/actions';
import { GenCustomTable } from '../../components/customComponents/genCustomTable/GenCustomTable';
import Header from '../../components/layout/Header';
import { USER_ROLE, initials, label } from '../../constants/garmentCodes';

export const AUDIT_ENTITY_TYPES = ['PaymentReceipt', 'LedgerEntry', 'FabricOption', 'Design', 'Order', 'Requirement', 'User', 'Engagement'];

export default function AuditLog() {
  const dispatch = useDispatch();
  const [params] = useSearchParams();
  const engagementId = params.get('engagementId') || '';
  const [entityType, setEntityType] = useState('');
  const [brandFilter, setBrandFilter] = useState('');
  const logs = useSelector((state) => state.auditlog.logs);
  const loading = useSelector((state) => state.auditlog.loading);
  const brands = useSelector((state) => state.brand.brands);

  useEffect(() => {
    dispatch(getAllBrands());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAllAuditLogs({ entityType, brandId: brandFilter, engagementId }));
  }, [dispatch, entityType, brandFilter, engagementId]);

  return (
    <div className="flex-1 flex flex-col min-h-0">
      <Header title="Audit Log" breadcrumbs={[{ workspace: true }, { label: 'Audit Log' }]} />
      <main className="flex-1 overflow-auto p-6 pb-20 md:pb-6">
        <div className="flex items-center gap-3 mb-4">
          <select value={entityType} onChange={(e) => setEntityType(e.target.value)} className="text-[12px] border border-gray-200 rounded-lg px-3 py-1.5 bg-white focus:outline-none">
            <option value="">All entities</option>
            {AUDIT_ENTITY_TYPES.map((t) => <option key={t}>{t}</option>)}
          </select>
          <select value={brandFilter} onChange={(e) => setBrandFilter(e.target.value)} className="text-[12px] border border-gray-200 rounded-lg px-3 py-1.5 bg-white focus:outline-none">
            <option value="">All brands</option>
            {brands.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
          </select>
          {loading && <span className="text-[11px] text-gray-400">Loading…</span>}
        </div>

        <div className="bg-white rounded-lg border border-gray-100 overflow-hidden [&_.MuiTablePagination-toolbar]:!justify-end [&_.MuiTablePagination-spacer]:!flex-1 [&_.MuiTablePagination-spacer]:!block [&_.MuiTablePagination-selectLabel]:!m-0 [&_.MuiTablePagination-displayedRows]:!m-0 [&_.MuiTablePagination-root]:!text-[#5C5A54]">
          <GenCustomTable
            isExportEnabled={true}
            exportFileName="Audit Log"
            columns={[
              { id: 'user', label: 'USER', align: 'left' },
              { id: 'role', label: 'ROLE', align: 'left' },
              { id: 'action', label: 'ACTION', align: 'left' },
              { id: 'entity', label: 'ENTITY', align: 'left' },
              { id: 'entityId', label: 'ENTITY ID', align: 'left' },
              { id: 'brand', label: 'BRAND', align: 'left' },
              { id: 'summary', label: 'SUMMARY', align: 'left' },
              { id: 'ip', label: 'IP', align: 'left' },
            ]}
            rows={logs.map((entry) => {
              const userName = entry.userName || 'System';
              return {
                id: entry.id,
                rColumns: [
                  <div key="user" label={userName} className="flex items-center gap-2 w-full h-full px-2 py-1">
                    <div className="w-6 h-6 bg-[#1b3a6b] rounded-full flex items-center justify-center text-white text-[9px] font-bold flex-shrink-0">{initials(userName)}</div>
                    <span className="text-[12px] text-gray-800">{userName}</span>
                  </div>,
                  <div key="role" label={label(USER_ROLE, entry.role)} className="flex items-center w-full h-full px-2 py-1 text-[11px] text-gray-500">{label(USER_ROLE, entry.role)}</div>,
                  <div key="act" label={entry.action || ''} className="flex items-center w-full h-full px-2 py-1 text-[12px] font-medium text-gray-800">{entry.action || '—'}</div>,
                  <div key="ent" label={entry.entityType || ''} className="flex items-center w-full h-full px-2 py-1 text-[12px] text-gray-600">{entry.entityType || '—'}</div>,
                  <div key="eid" label={String(entry.entityId ?? '')} className="flex items-center w-full h-full px-2 py-1 font-mono text-[11px] text-[#1b3a6b]">{entry.entityId != null ? `#${entry.entityId}` : '—'}</div>,
                  <div key="brand" label={entry.brandName || ''} className="flex items-center w-full h-full px-2 py-1 text-[12px] text-gray-600">{entry.brandName || '—'}</div>,
                  <div key="summary" label={entry.summary || ''} className="flex items-center w-full h-full px-2 py-1 text-[12px] text-gray-500 max-w-xs truncate">{entry.summary || '—'}</div>,
                  <div key="ip" label={entry.ip || ''} className="flex items-center w-full h-full px-2 py-1 font-mono text-[11px] text-gray-400">{entry.ip || '—'}</div>,
                ],
              };
            })}
          />
          {!loading && logs.length === 0 && <p className="py-10 text-center text-[12px] text-gray-400">No audit events</p>}
        </div>
      </main>
    </div>
  );
}
